import {alias, createModelSchema, list} from "serializr";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {PiggyMechanicType} from "@/modules/redactor/models/smart-offer/bundle-piggy/PiggyMechanicType";
import {PiggyStageConfig} from "@/modules/redactor/models/smart-offer/bundle-piggy/PiggyStageConfig";
import {Schema} from "@/common/Schema";

export class SmartOfferBundlePiggy extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.PIGGY);

        this._stageUp = 0;
        this._stageDown = 0;

        this._mechanic = null;
        this._stages = [];
    }

    get mechanic() {
        return this._mechanic;
    }

    set mechanic(value) {
        this._mechanic = value;
    }

    get stages() {
        return this._stages;
    }

    set stages(value) {
        this._stages = value;
    }

    get stageUp() {
        return this._stageUp;
    }

    set stageUp(value) {
        this._stageUp = value;
    }

    get stageDown() {
        return this._stageDown;
    }

    set stageDown(value) {
        this._stageDown = value;
    }

    valid() {
        if (!super.valid()) {
            return false;
        }

        if (!Number.isInteger(this.stageUp) || this.stageUp < 0) {
            return false;
        }

        if (!Number.isInteger(this.stageDown) || this.stageDown < 0) {
            return false;
        }

        if (!PiggyMechanicType.is(this.mechanic)) {
            return false;
        }

        if (!this.stages || this.stages.length === 0 || this.stages.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundlePiggy());
        } else if (target instanceof SmartOfferBundlePiggy) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundlePiggy, {
    _mechanic: alias("mechanic", PiggyMechanicType.schema()),
    _stages: alias("stages", list(PiggyStageConfig.schema())),
    _stageUp: alias("stage_up", Schema.primitive()),
    _stageDown: alias("stage_down", Schema.primitive())
});
